import { createContext } from 'react'

export const defaultUIConfig = {
	disableTakePhoto: false,
}

export const UIConfigContext =
	createContext<typeof defaultUIConfig>(defaultUIConfig)
